module.exports = __webpack_public_path__ + "img/lize01.48db9c6f.png";